<template>
  <PatientExaminationHeader
    :examination-collection="collection"
    :is-expanded="isExpanded"
    :is-open="isOpen"
    :has-last-consultation-column-header="
      productDefinition.patient_overview.hasLastConsultationColumnHeader
    "
    :product-definition="productDefinition"
    @click="onHeaderClick"
  />

  <tr v-if="isOpen" class="hiddenRow">
    <td :colspan="nrOfColumns" class="hiddenRowContent">
      <PatientExaminationContainer
        class="pt-3"
        :product-definition="productDefinition"
        :examination-collection="examinations"
        :loading="loading"
      />
    </td>
  </tr>
</template>

<script setup lang="ts">
import { ref, provide } from "vue";
import PatientExaminationHeader from "./PatientExaminationHeader.vue";
import PatientExaminationContainer from "./PatientExaminationContainer.vue";
import { practitionerHttpService } from "../../../../app/practitioner-portal/store/practitioner-http-service";
import Notifications from "../../../Utils/notifications";

const props = defineProps<{
  collection: any;
  productDefinition: any;
  isExpanded: boolean;
  nrOfColumns: number;
}>();
const isOpen = ref(false);
const examinations = ref([]);
const loading = ref(false);

async function fetchExaminations() {
  const response = await practitionerHttpService.get(
    `/api/internal/examination/tumour-wound/${props.collection.main_examination.id}`,
  );
  if (response && response.data && response.data.examinations) {
    const firstExam = response?.data?.examinations?.[0];
    examinations.value = [
      ...(firstExam?.examinations ?? []),
      firstExam?.main_examination ?? null,
    ];
  }
}

provide("reloadMainExamination", fetchExaminations);

async function onHeaderClick(event) {
  const btnClicked =
    event.target?.parentElement?.className.includes("dropdown") ||
    event.target?.parentElement?.parentElement?.className.includes("dropdown");
  if (!btnClicked) {
    isOpen.value = !isOpen.value;
    loading.value = true;
    if (examinations.value.length === 0) {
      try {
        await fetchExaminations();
      } catch (error) {
        Notifications.error("errorMessages.genericUnexpectedErrorMessage");
        console.error("Failed to fetch examinations", error);
        isOpen.value = !isOpen.value;
      } finally {
        loading.value = false;
      }
    } else {
      loading.value = false;
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  border-collapse: separate;
  border-spacing: 0 0.3rem;

  tr {
    td {
      border-bottom: 2px solid #f5f5f5 !important;

      &:first-of-type {
        border-left: 2px solid #f5f5f5;
      }

      &:last-of-type {
        border-right: 2px solid #f5f5f5;
      }
    }
  }
}
.hiddenRow {
  background: #ffff;
  color: #676a6c !important;

  .hiddenRowContent .collapse.show {
    border-top: 2px solid #dee2e6 !important;
  }

  .hiddenRowContent {
    padding: 0 !important;
    position: relative;
    top: -5px;
    border-top: none;
  }

  &:hover {
    background-color: #ffff;
  }
}
</style>
